import { render, staticRenderFns } from "./youtube-star.vue?vue&type=template&id=32b39d80&scoped=true"
import script from "./youtube-star.vue?vue&type=script&lang=js"
export * from "./youtube-star.vue?vue&type=script&lang=js"
import style0 from "./youtube-star.vue?vue&type=style&index=0&id=32b39d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b39d80",
  null
  
)

export default component.exports